import { render, staticRenderFns } from "./TaskReward.vue?vue&type=template&id=2b0d2448&"
import script from "./TaskReward.vue?vue&type=script&lang=js&"
export * from "./TaskReward.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports